import React, { ComponentType, ReactNode, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { TabContainerAfterTitleWithScroll } from '../style/containers';
import { RouteConfigItemType } from './types';

type NavigationMenuProps = {
  items: RouteConfigItemType[];
  style?: Record<string, string>;
};

const withSuspenseAndWrapper = <P extends object>(
  Component: ComponentType<P>,
  Wrapper: ComponentType<{
    children: ReactNode;
  }> = TabContainerAfterTitleWithScroll,
  props: P
) => (
  <Suspense>
    <Wrapper>
      <Component {...props} />
    </Wrapper>
  </Suspense>
);

export const SettingsRouteConfiguration = ({ items }: NavigationMenuProps) => {
  return (
    <Routes>
      {items.map(({ path, element: Component, props = {}, wrapper }) => (
        <Route
          key={path}
          path={path}
          element={withSuspenseAndWrapper(Component, wrapper, { ...props })}
        />
      ))}
    </Routes>
  );
};
